import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AdminService } from '../../services/admin.service';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/auth-module/services/auth.service';

@Component({
  selector: 'app-facility-listing',
  templateUrl: './facility-listing.component.html',
  styleUrls: ['./facility-listing.component.scss']
})
export class FacilityListingComponent implements OnInit {

  // columnNames = ['S.No.', 'Name Of Facility', 'State', 'Manyata Progress', 'Amount Approved', 'Payment Status', 'Profile Completion %'];
  columnList = [
    {
      name: 'S.No.',
      textAlign: 'center',
    },
    {
      name: 'Name Of Facility',
      textAlign: 'start',
      paddingLeft: '30px',
    },
    {
      name: 'State',
      textAlign: 'start',
    },
    {
      name: 'Manyata Progress',
      textAlign: 'center',
    },
    {
      name: 'Amount Approved',
      textAlign: 'center',
    },
    {
      name: 'Payment Status',
      textAlign: 'center',
    },
    {
      name: 'Profile Completion %',
      textAlign: 'center',
    },
  ]

  tableData = []
  facilityParams: string = ''
  showFilterContainer: boolean = false;
  facility_name = '';
  state_name = '';
  stateList = [];
  totalData: any;
  searchFacility = '';
  payment_status = '';
  paymentStatusList = ['Completed', 'Partially Completed', 'Pending For Approval', 'Pending', 'Rejected'];
  payment_status_params = '';
  csvDownloadAPI = 'user/csv';
  csvFileName = 'facility-list';
  @Output() showSideBar = new EventEmitter();
  showSideMenu: boolean = false;

  constructor(private adminService: AdminService, private authService: AuthService) {
    if (sessionStorage.getItem('isClearFilter') == 'true') {
      this.showFilterContainer = false;
      sessionStorage.removeItem('search_facility_name');
    }
  }

  ngOnInit(): void {
    if (sessionStorage.getItem('search_facility_name') !== null) {
      this.facilityParams = `facility_name=${sessionStorage.getItem('search_facility_name')}`;
      this.searchFacility = sessionStorage.getItem('search_facility_name');
    } else if ((sessionStorage.getItem('filter_facility_name') !== null || sessionStorage.getItem('filter_state_name') !== null || sessionStorage.getItem('filter_payment_status') !== null) && sessionStorage.getItem('isClearFilter') !== 'true') {
      this.showFilterContainer = true;
    }

    this.getFacilityDetails();
  }

  getFacilityDetails() {
    // console.log(this.facilityParams);
    this.adminService.getFacilityListing(`${this.facilityParams}&limit=10`, sessionStorage.getItem("token")).subscribe((response: any) => {
      // console.log(response['data']);
      this.tableData = response?.data;
      this.totalData = response?.total;
    })
  }

  tableSearch(event) {
    console.log(event.target.value);
    if (event.target.value != '') {
      sessionStorage.setItem("search_facility_name", event.target.value);
      this.facilityParams = `facility_name=${event.target.value}`;
    } else {
      this.facilityParams = '';
      sessionStorage.removeItem('search_facility_name');
    }

    this.facility_name = '';
    this.state_name = '';
    this.payment_status = '';
    // this.facilityParams = '';
    sessionStorage.removeItem('filter_facility_name');
    sessionStorage.removeItem('filter_state_name');
    sessionStorage.removeItem('filter_payment_status');


    this.getFacilityDetails();
  }

  tableFilter() {
    this.showFilterContainer = !this.showFilterContainer;
    this.searchFacility = '';
    sessionStorage.removeItem('search_facility_name');

    if (this.showFilterContainer == false) {
      sessionStorage.removeItem('filter_facility_name');
      sessionStorage.removeItem('filter_state_name');
      sessionStorage.removeItem('filter_payment_status');
      this.facilityParams = '';
      this.getFacilityDetails();
    }

  }

  handlePagination(pageEvent) {
    this.facilityParams = `facility_name=${this.facility_name}&state_name=${this.state_name}&${this.payment_status_params}&page=${pageEvent}`;
    this.getFacilityDetails();
  }

  responseOnFilter(filterValue) {
    console.log('searchedParams', filterValue);
    this.state_name = filterValue?.state_name
    this.payment_status_params = filterValue?.payment_status_params
    
    this.facilityParams = `state_name=${this.state_name}&${this.payment_status_params}`;
    sessionStorage.removeItem('search_facility_name');
    this.searchFacility = '';
    this.getFacilityDetails();
  }

  showSideBarMenu() {
    this.showSideMenu = !this.showSideMenu;
    this.showSideBar.emit(this.showSideMenu)
  }
}
